import Page from "webPage/Page";
import FormValidator from "base/FormValidator";
import Ajax from "base/Ajax";
import PromiseHelper from "base/PromiseHelper";

Page.register('/training/?$', function () {

    $("body").on("click", ".js-training-enquire", function () {
        $(".js-course-select").val($(this).parents(".training").attr("data-id")).change();
        $("body").toggleClass("modal-active");
        $(".js-training-modal").addClass("modal--active");
        $(".js-course-form").removeClass("form--success form--error");
        return false;
    }).on("change", ".js-course-select", function () {
        $(".js-course-select-text").text($(this).find("option:selected").text());
    }).on("click", ".js-retry-course", () => {
        let $form = $(".js-course-form");
        if (!$form.is(".form--validation-error")) {
            $form.submit()
        }
        $form.removeClass("form--success form--error form--validation-error");
        return false;
    });

    $(".js-course-select").change();
    FormValidator.attach($(".js-course-form"), {inputOptions: {operator: 'your'}}).on("input:invalid", ({input}) => {
        input.$input.parents(".form__row").addClass("form__row--invalid");
    }).on("input:valid", ({input}) => {
        input.$input.parents(".form__row").removeClass("form__row--invalid");
    }).on("submit", ($form) => {
        let $btn = $form.find("button[type=submit]");
        if ($btn.is(".btn--loading")) return;
        $btn.addClass('btn--loading');
        $(".js-course-form").removeClass("form--success form--error form--validation-error");
        let timed = PromiseHelper.timed_promise(500);

        Promise.all([Ajax.post("hateCrime", "training", $form.serializeJSON(), Ajax.WEBSITE), timed]).then(() => {
            $btn.removeClass('btn--loading');
            $(".js-course-form").addClass("form--success").removeClass("form--error");
        }).catch((e) => {
            timed.then(() => {
                $btn.removeClass('btn--loading');
                $(".js-course-form").addClass("form--error").removeClass("form--success form--validation-error");

                if (e.data && e.data.exception === 'HttpValidationException') {
                    $form.data("Validator").handleValidationException(e);
                    $(".js-course-form").addClass("form--validation-error");
                }
            });
        })
    });
});
